import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Route, Routes, Navigate } from "react-router-dom";
import CreateClient from "../Client/CreateClient";
import Clientdetail from "../Client/Clientdetail";
import Clientdetails from "../Client/Clientdetails";
import Sidebar from "./Sidebar";
import Breadcrumbs from "./Breadcrumbs";
import ChecklistDetails from "../Checklist/ChecklistDetails";
import CheckListManagement from "../Checklist/ChecklistManagement";
import ViewChecklistDetails from "../Checklist/ViewCheckListDetails";
import IdpConfiguration from "../idp/IdpConfiguration";
import EmailTemplateUI from "../Email/EmailTemplateUI";
import CreateTemplatePage from "../Email/CreateTemplate";
import ClientSelectionComponent from "../Email/ClientSelectionComponent";
import EditTemplatePage from "../Email/EditTemplate";
import FunctionChecklist from "../FunctionChecklist/FunctionChecklist";
import FunctionChecklistDetails from "../FunctionChecklist/FunctionChecklistDetails";
import FunctionViewCheckListDetails from "../FunctionChecklist/FunctionViewCheckListDetails";
import Login from "./Login";
import { apiCall } from "./Apicall";
import User from "./User";
import "../css/main/App.css";
interface AppProps { future?: { v7_startTransition: boolean; v7_relativeSplatPath: boolean } }
const App: React.FC<AppProps> = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState<boolean>(false);
  const [isAuthenticated, setIsAuthenticated] = useState<string | null>(null);
  const [, setShowProjects] = useState<boolean>(false);
  const [loading, setLoading] = useState(true);
  const [isMobile, setIsMobile] = useState<boolean>(false);
  const [shouldBlurContent, setShouldBlurContent] = useState<boolean>(false);
  useEffect(() => {
    const token = localStorage.getItem("accessToken");
    if (token) {
      setIsAuthenticated(token);
    }
    setLoading(false);
  }, []);
  useEffect(() => {
    const checkMobile = () => {
      const mobile = window.innerWidth <= 768;
      setIsMobile(mobile);
      if (mobile) {
        setIsSidebarOpen(false);
      }
    };
    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);
  const handleLogout = async () => {
    const token = localStorage.getItem("accessToken");
    try {
      if (token) {
        await apiCall("post", "/api/auth/logout", {});
      }
      localStorage.clear();
      setIsAuthenticated(null);
    } catch (error) {
      console.error("Logout failed:", error);
    }
  };
  const toggleSidebar = (): void => {
    setIsSidebarOpen((prev) => !prev);
  };
  const handleSidebarToggle = (isOpen: boolean) => {
    if (isMobile && isOpen) {
      setShouldBlurContent(true);
      document.body.style.overflow = 'hidden';
    } else {
      setShouldBlurContent(false);
      document.body.style.overflow = 'auto';
    }
  };
  if (loading) return null;
  const routerFutureFlags = { v7_startTransition: true, v7_relativeSplatPath: true };
  const contentClass = `app-content ${shouldBlurContent ? 'blurred' : ''} ${isMobile ? 'mobile-content' : isSidebarOpen ? 'sidebar-open' : 'sidebar-closed'}`;
  return (
    <Router future={routerFutureFlags}>
      {!isAuthenticated ? (
        <Routes>
          <Route path="/login" element={<Login setToken={setIsAuthenticated} />} />
          <Route path="*" element={<Navigate to="/login" replace />} />
        </Routes>
      ) : (
        <div className="app-container">
          <Sidebar isSidebarOpen={isSidebarOpen} toggleSidebar={toggleSidebar} setShowProjects={setShowProjects} setIsAuthenticated={setIsAuthenticated} onSidebarToggle={handleSidebarToggle} isMobile={isMobile} />
          {isMobile && !isSidebarOpen && (
            <button className="mobile-sidebar-toggle" onClick={toggleSidebar} aria-label="Open sidebar">
              <span>☰</span>
            </button>
          )}
          <div className={contentClass} onClick={() => { if (shouldBlurContent) toggleSidebar(); }}>
            <Breadcrumbs handleLogout={handleLogout} />
            <Routes>
              <Route path="/client" element={<Clientdetail />} />
              <Route path="/client-details/:clientId" element={<Clientdetails />} />
              <Route path="/Createclient" element={<CreateClient />} />
              <Route path="/checklistmanagement" element={<CheckListManagement />} />
              <Route path="/checklistdetails/:templateId" element={<ChecklistDetails />} />
              <Route path="/viewchecklistdetails/:templateId" element={<ViewChecklistDetails />} />
              <Route path="/functionchecklist" element={<FunctionChecklist />} />
              <Route path="/functionchecklistdetails/:functionTemplateId" element={<FunctionChecklistDetails />} />
              <Route path="/functionviewchecklistdetails/:functionTemplateId" element={<FunctionViewCheckListDetails />} />
              <Route path="/idpConfiguration" element={<IdpConfiguration />} />
              <Route path="/templates" element={<ClientSelectionComponent />} />
              <Route path="/templatesdetails/:clientId" element={<EmailTemplateUI />} />
              <Route path="/createtemplate/:clientId" element={<CreateTemplatePage />} />
              <Route path="/emailtemplatedetail/:clientId/:templateId" element={<EditTemplatePage />} />
              <Route path="/usermanagement" element={<User />} />
              <Route path="*" element={<Navigate to="/client" replace />} />
            </Routes>
          </div>
        </div>
      )}
    </Router>
  );
};
export default App;